module.exports = __webpack_public_path__ + "img/units.aef04769.svg";